export default "__VITE_ASSET__DbLSxzAQ__"